import axiosInstance from '../utils/setupAxios';

export const getPayments = (params = {}) =>
  axiosInstance.get('/songs/payments', { params });

export const getPaymentById = (id) =>
  axiosInstance.get(`/songs/payments/${id}`);

export const getLatestPayments = (since = null, limit = 10) => {
  const params = { limit };
  if (since) params.since = since;
  return axiosInstance.get('/songs/payments/latest', { params });
};

export const getLast7DaysPaymentRevenue = () =>
  axiosInstance.get('/songs/payments/last-7-days-revenue');

export const getTopPayingDevices = () =>
  axiosInstance.get('/songs/statistics/top-paying-devices');

export const getTopProductsByRevenue = () =>
  axiosInstance.get('/songs/statistics/top-products');

export const getPaymentProductList = () =>
  axiosInstance.get('/songs/payments/product-list');
